class CollectionCarousel {
  constructor(root) {
    this.root = root;
    this.viewport = root.querySelector('.cc-track-viewport');
    this.track = root.querySelector('.cc-track');
    this.slides = Array.from(this.track.children);
    this.prevBtn = root.querySelector('.cc-arrow-prev');
    this.nextBtn = root.querySelector('.cc-arrow-next');

    this.currentIndex = 0;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.isDragging = false;

    if (!this.slides.length) return;

    this.bindEvents();
    this.update();
    window.addEventListener('resize', () => this.update());
  }

  get visiblePerView() {
    const width = window.innerWidth;
    if (width <= 749) return parseInt(getComputedStyle(this.track).getPropertyValue('--cc-visible-mobile')) || 1;
    if (width <= 989) return parseInt(getComputedStyle(this.track).getPropertyValue('--cc-visible-tablet')) || 3;
    return parseInt(getComputedStyle(this.track).getPropertyValue('--cc-visible')) || 4;
  }

  get maxIndex() {
    return Math.max(0, this.slides.length - this.visiblePerView);
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.go(this.currentIndex - 1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.go(this.currentIndex + 1));
    }

    // Touch / drag support (works on mobile, tablet, and desktop drag)
    this.track.addEventListener('touchstart', (e) => this.dragStart(e), { passive: true });
    this.track.addEventListener('touchmove', (e) => this.dragMove(e), { passive: true });
    this.track.addEventListener('touchend', () => this.dragEnd());

    this.track.addEventListener('mousedown', (e) => this.dragStart(e));
    window.addEventListener('mousemove', (e) => this.dragMove(e));
    window.addEventListener('mouseup', () => this.dragEnd());
  }

  getPositionX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  dragStart(e) {
    this.isDragging = true;
    this.startX = this.getPositionX(e);
    this.track.classList.add('is-dragging');
  }

  dragMove(e) {
    if (!this.isDragging) return;
    const currentX = this.getPositionX(e);
    this.currentTranslate = this.prevTranslate + (currentX - this.startX);
  }

  dragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.classList.remove('is-dragging');

    const movedBy = this.currentTranslate - this.prevTranslate;

    if (movedBy < -50 && this.currentIndex < this.maxIndex) {
      this.currentIndex += 1;
    } else if (movedBy > 50 && this.currentIndex > 0) {
      this.currentIndex -= 1;
    }

    this.currentTranslate = this.prevTranslate;
    this.update();
  }

  go(index) {
    this.currentIndex = Math.max(0, Math.min(index, this.maxIndex));
    this.update();
  }

  update() {
    const slideWidth = this.slides[0].getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    const offset = this.currentIndex * (slideWidth + gap);

    this.prevTranslate = -offset;
    this.currentTranslate = this.prevTranslate;
    this.track.style.transform = `translateX(${this.prevTranslate}px)`;

    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex <= 0;
      this.prevBtn.classList.toggle('is-visible', this.currentIndex > 0);
    }
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cc-section').forEach((section) => {
    new CollectionCarousel(section);
  });
});